import React, { useEffect } from "react";
import { BundleInterface } from "src/store/callrecorder/bundlesSlice";

import { Button, Form, Input, Switch } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: BundleInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const platform = Form.useWatch('platform', form);
  const isAndroid = platform === 'android';

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={{ platform: 'ios', ...params }}
    >
      <Form.Item name='name' label="Name">
        <Input disabled={!!params?.id} />
      </Form.Item>

      <Form.Item
        name='platform'
        label="Platform"
        getValueProps={(value) => ({ checked: value === 'android' })}
        getValueFromEvent={(checked: boolean) => (checked ? 'android' : 'ios')}
      >
        <Switch
          checkedChildren='android'
          unCheckedChildren='ios'
        />
      </Form.Item>

      <Form.Item name='twilio_service_sid' label="Twilio Service SID">
        <Input />
      </Form.Item>

      {!isAndroid && (
        <>
          <Form.Item name='shared_secret' label="Shared Secret">
            <Input />
          </Form.Item>

          <h6 className="v-content-label o-sm">
            APNs Auth Key
          </h6>

          <p className="v-mb-10" style={{ opacity: 0.7 }}>
            One <code>.p8</code> auth key covers both standard push and PushKit VoIP wake-ups.
          </p>

          <FileDropzone name='push_cert' label='Auth Key (.p8)' preview={params?.push_cert_url || undefined} />

          <Form.Item name='team_id' label="Apple Team ID">
            <Input placeholder="e.g. ABCD1234EF" />
          </Form.Item>

          <Form.Item name='apns_key_id' label="APNs Key ID">
            <Input placeholder="e.g. ABC123DEFG" />
          </Form.Item>

          <h6 className="v-content-label o-sm">
            StoreKit2 API Keys {' '}
            <a href="https://developer.apple.com/documentation/StoreKit/generating-jws-to-sign-app-store-requests#Get-your-key-ID-and-issuer-ID-from-App-Store-Connect" target="_blank" rel="noreferrer" style={{ fontWeight: 400 }}>
              docs
            </a>
          </h6>

          <FileDropzone name='app_store_connect_api_private_key' label='Private Key (.p8)' preview={params?.app_store_connect_api_private_key_url || undefined} />

          <Form.Item name='app_store_connect_api_key_id' label="Key ID">
            <Input />
          </Form.Item>

          <Form.Item name='app_store_connect_api_issuer_id' label="Issuer ID">
            <Input />
          </Form.Item>
        </>
      )}

      {isAndroid && (
        <>
          <h6 className="v-content-label o-sm">
            Firebase Service Account {' '}
            <a href="https://firebase.google.com/docs/admin/setup#initialize_the_sdk_in_non-google_environments" target="_blank" rel="noreferrer" style={{ fontWeight: 400 }}>
              docs
            </a>
          </h6>

          <p className="v-mb-10" style={{ opacity: 0.7 }}>
            Used for both Play purchase verification and FCM push notifications. Grant the service account
            {' '}<code>androidpublisher</code> and <code>firebase.messaging</code> IAM roles. Values map to the
            {' '}<code>project_id</code>, <code>client_email</code>, and <code>private_key</code> fields of the
            Firebase Admin SDK service account JSON.
          </p>

          <Form.Item name='firebase_project_id' label="Project ID">
            <Input placeholder="e.g. my-firebase-project" />
          </Form.Item>

          <Form.Item name='firebase_client_email' label="Client Email">
            <Input placeholder="e.g. firebase-adminsdk@my-project.iam.gserviceaccount.com" />
          </Form.Item>

          <Form.Item name='firebase_private_key' label="Private Key">
            <Input.TextArea autoSize={{ minRows: 4, maxRows: 12 }} placeholder="-----BEGIN PRIVATE KEY-----..." />
          </Form.Item>
        </>
      )}

      <Form.Item label="Environment" name='prod_env' valuePropName='checked'>
        <Switch
          checkedChildren='production'
          unCheckedChildren='development'
        />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
